document.addEventListener('DOMContentLoaded', function() {
  if (typeof customer !== 'undefined' && customer) {
    // UI Toggle Functions
    const toggleUI = {
      showSignIn: () => {
        document.getElementById('dashboard-content').style.display = 'none';
        document.getElementById('caring-signin-prompt').style.display = 'flex';
      },
      showDashboard: () => {
        document.getElementById('dashboard-content').style.display = 'block';
        document.getElementById('caring-signin-prompt').style.display = 'none';
      }
    };
    
    // Update Account Details
    const updateAccountDetails = (memberData) => {
      const fields = {
        'customer-first-name': memberData.Name || 'N/A',
        'customer-last-name': memberData.LastName || 'N/A',
        'customer-gender': memberData.Gender === 'F' ? 'Female' : memberData.Gender === 'M' ? 'Male' : memberData.Gender || 'N/A',
        'customer-email': memberData.Email || 'N/A',
        'customer-phone': memberData.Mobile || 'N/A',
        'customer-dob': memberData.DOB ? new Date(memberData.DOB).toLocaleDateString('en-US', {
          year: 'numeric', month: 'long', day: 'numeric'
        }) : 'N/A',
        'customer-address': [memberData.Addr1, memberData.Addr2].filter(Boolean).join(', ') || 'N/A'
      };
      
      Object.entries(fields).forEach(([id, value]) => {
        document.getElementById(id).textContent = value;
      });
    };
    
    // Update Points and Expiry
    const updatePointsExpiry = (data) => {
      const pointsElement = document.getElementById('customer-points-value');
      const expiryList = document.getElementById('expiry-list');
      
      pointsElement.textContent = Number(data.balance ?? 0).toLocaleString();
      
      if (data.PointExpiry?.length) {
        expiryList.innerHTML = data.PointExpiry.map(expiry => `
          <li class="expiry-item">
            <span class="expiry-month">${expiry.md}</span>
            <span class="expiry-amount">${expiry.ep}</span>
          </li>
        `).join('');
      }
    };
    
    // Update Tier Information
    const updateTierInfo = (data) => {
      if (!data.TierNotify) return;
      
      const tierNotifyFull = data.TierNotify.TierNotifyFull;
      const sections = tierNotifyFull?.split('<br><br>') || [];
      
      // Update tier info list
      const tierInfo = document.getElementById('tier-info');
      tierInfo.innerHTML = sections.flatMap(section => 
        section.split('<br>')
          .map(part => part.replace(/<\/?b>/g, '').trim())
          .filter(Boolean)
          .map(text => `<li>${text}</li>`)
      ).join('');
      
      // Extract and update tier labels
      const tierMatch = sections[0]?.match(/Your\s+(\w+)\s+Tier/);
      if (tierMatch) {
        const currentTier = tierMatch[1];
        document.getElementById('tier-status-title').textContent = `Member Tier Status - ${currentTier} Tier`;
        document.getElementById('current-tier-label').textContent = currentTier;
        
        const tierBadge = document.getElementById('tier-badge');
        tierBadge.textContent = 'Benefits';
        tierBadge.className = 'tier-badge';
      }
      
      // Extract next tier from "Tier up to [Tier] Member"
      let nextTier = null;
      
      // Check section 1 first, then section 2
      if (sections[1]) {
        const upgradeText = sections[1];
        const nextTierMatch = upgradeText.match(/Tier up to\s+(\w+)\s+Member/);
        if (nextTierMatch) {
          nextTier = nextTierMatch[1];
        }
      }
      
      // If not found in section 1, check section 2
      if (!nextTier && sections[2]) {
        const upgradeText = sections[2];
        const nextTierMatch = upgradeText.match(/Tier up to\s+(\w+)\s+Member/);
        if (nextTierMatch) {
          nextTier = nextTierMatch[1];
        }
      }
      
      // Top-tier members have no "Tier up to" sentence (Caring says "Maintain as
      // Platinum Member..." instead). Leave the label empty: CSS hides it, so the
      // bar shows only the current tier.
      document.getElementById('next-tier-label').textContent = nextTier || '';
      
      // Update progress bar
      const progressText = document.getElementById('progress-text');
      const progressFill = document.getElementById('progress-fill');
      
      if (data.TierNotify.TierNotifyCustom) {
        const tierCustom = data.TierNotify.TierNotifyCustom;
        const totalSpending = parseFloat(tierCustom.totalSpending) || 0;
        const nextTierAmount = parseFloat(tierCustom.nextTierAmount.replace(/,/g, '')) || 0;
        const progressPercentage = (totalSpending / (totalSpending + nextTierAmount)) * 100;
        
        progressFill.style.width = progressPercentage + '%';
        progressText.textContent = `RM${totalSpending.toLocaleString()} / RM${(totalSpending + nextTierAmount).toLocaleString()}`;
      } else {
        progressText.textContent = 'Progress information unavailable';
        progressFill.style.width = '0%';
      }
    };
    
    // Update Vouchers
    const updateVouchers = (data) => {
      const voucherList = document.getElementById('customer-voucher-list');
      const vouchers = data.voucher?.voucher?.filter(v => v.Status === 'AWARDED') || [];
      
      if (vouchers.length === 0) {
        voucherList.innerHTML = '<div class="voucher-item"><div class="voucher-info"><div class="voucher-description">No available vouchers</div></div></div>';
        return;
      }
      
      const currentDate = new Date();
      voucherList.innerHTML = vouchers.map(voucher => {
        const expiryDate = new Date(voucher.ExpiryDate);
        const validDate = new Date(voucher.ValidDate);
        const isValid = currentDate >= validDate && currentDate <= expiryDate;
        
        return `
          <div class="voucher-item" onclick="window.location.href='/cart'">
            <div class="voucher-info">
              <div class="voucher-code">${voucher.VoucherNo}</div>
              <div class="voucher-validity">Valid until: ${expiryDate.toLocaleDateString()}</div>
              <div class="voucher-details">
                <small>Min spend: RM${voucher.MinSpdAmt}</small>
              </div>
            </div>
            <div class="voucher-status">
              <span class="status-badge ${isValid ? 'active' : 'expired'}">${isValid ? 'Active' : 'Expired'}</span>
            </div>
          </div>
        `;
      }).join('');
    };
    
    // Main Fetch Function - Single API call for tags, parallel fetching for data
    fetch('https://shopify-caring.gadget.app/caring-login-info', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shopifyId: `gid://shopify/Customer/${customer.id}` })
    })
    .then(res => res.json())
    .then(info => {
      if (!info.success || !Array.isArray(info.tags) || info.tags.length === 0) {
        toggleUI.showSignIn();
        throw new Error('No customer tags found');
      }
      
      toggleUI.showDashboard();
      
      // Extract phone and card number from tags
      const phoneTag = info.tags.find(tag => tag.startsWith('CP_'));
      const cardTag = info.tags.find(tag => tag.startsWith('CM_'));
      
      if (!phoneTag || !cardTag) {
        toggleUI.showSignIn();
        throw new Error('Missing required tags');
      }
      
      const customerPhone = phoneTag.slice(3);
      const cardNumber = cardTag.slice(3);
      
      // Fetch member details and balance in parallel
      return Promise.all([
        fetch('https://shopify-caring.gadget.app/search-member', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: customerPhone })
        }).then(res => res.json()),
        fetch('https://shopify-caring.gadget.app/caring-login-info', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cardNo: cardNumber })
        }).then(res => res.json())
      ]);
    })
    .then(([memberResult, balanceResult]) => {
      // Update account details
      if (memberResult.data?.CardMember?.[0]) {
        updateAccountDetails(memberResult.data.CardMember[0]);
      }
      
      // Update balance, points, tier, and vouchers
      if (balanceResult.success && balanceResult.data) {
        updatePointsExpiry(balanceResult.data);
        updateTierInfo(balanceResult.data);
        updateVouchers(balanceResult.data);
      } else {
        document.getElementById('customer-points-value').textContent = '0';
      }
    })
    .catch(err => {
      console.log('Error:', err.message);
      if (err.message !== 'No customer tags found') {
        toggleUI.showSignIn();
      }
    });
  } else {
    document.getElementById('caring-signin-prompt').style.display = 'flex';
  }
});
